// extracted by mini-css-extract-plugin
export default {"cardWrapper":"Card_cardWrapper__TvahP"};